import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { CAMPAIGN_REACHOUT_INFLUENCER_KEY } from "../constants";
import { CampaignReachoutService } from "../services/campaign.reachout.service";

export function useCampaignReachOut() {
  const {
    mutate: update,
    isLoading: isUpdating,
    isSuccess: isUpdated,
  } = useMutation<
    {
      brandName: string;
      briefName: string;
      deliverables: string;
      timeline: string;
      socialMedias: {
        username: string;
        emailId: string;
        platform: string;
        isUserEntered: boolean;
      }[];
    },
    BackednResponse<{}> | void
  >({
    mutationFn: async (data) => {
      return await CampaignReachoutService.campaignReachOut(data).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      );
    },
    options: {
      queryKey: CAMPAIGN_REACHOUT_INFLUENCER_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, data) => {},
  });

  return {
    update,
    isUpdating,
    isUpdated,
  };
}
